// Infrastructure Layer - Adaptador para instalación PWA
export interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

export interface PWAInstallAdapter {
  canInstall(): boolean;
  promptInstall(): Promise<boolean>;
  isInstalled(): boolean;
}

export class WebPWAInstallAdapter implements PWAInstallAdapter {
  private deferredPrompt: BeforeInstallPromptEvent | null = null;

  constructor() {
    if (typeof window !== 'undefined') {
      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        this.deferredPrompt = e as BeforeInstallPromptEvent;
        window.dispatchEvent(new CustomEvent('pwa-installable'));
      });

      window.addEventListener('appinstalled', () => {
        this.deferredPrompt = null;
        window.dispatchEvent(new CustomEvent('pwa-installed'));
      });
    }
  }

  canInstall(): boolean {
    return this.deferredPrompt !== null;
  }

  async promptInstall(): Promise<boolean> {
    if (!this.deferredPrompt) {
      return false;
    }

    try {
      await this.deferredPrompt.prompt();
      const { outcome } = await this.deferredPrompt.userChoice;
      this.deferredPrompt = null;
      return outcome === 'accepted';
    } catch (error) {
      console.error('Error mostrando prompt de instalación:', error);
      return false;
    }
  }

  isInstalled(): boolean {
    if (typeof window === 'undefined') {
      return false;
    }

    // Verificar si está en modo standalone
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    const isIOSStandalone = (window.navigator as any).standalone === true;
    
    return isStandalone || isIOSStandalone;
  }
}
